import { useState, useContext } from 'react';
import axios from "axios";
import { CloudContext } from "../context/CloudContext";
import { AuthContext } from "../context/AuthContext";
import config from "../config";

export const useCredentials = () => {
    const {
        setRegion,
        setIdpool,
        setCloudinary_cloud,
        setCloudinary_preset,
        setCesium_token
    } = useContext(CloudContext);
    
    const { service } = useContext(AuthContext);

    const [processings, setProcessings] = useState([]);

    const getCredentials = async (jwt) => {
        let res = await axios.get(`${config.apiUrl}/api/credentials`, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        });
        let response = res.data.data[0].attributes;
        setRegion(response.region);
        setIdpool(response.identity_pool);
        setCloudinary_cloud(response.cloudinary_cloud);
        setCloudinary_preset(response.cloudinary_preset);

        //if(service === "mapping") 
            setCesium_token(response.cesium_token);
        //}
    };

    const retrieveProcessings = async (jwtStrapi) => {
        const res = await axios.get(`${config.apiUrl}/api/processings?populate=*`, {
            headers: {
                Authorization: `Bearer ${jwtStrapi}`,
            },
        });

        const simplifiedProcessings = res.data.data.map(item => ({
            id: item.id,
            title: item.attributes.title,
            description: item.attributes.description,
            url: item.attributes.url,
            output: item.attributes.output,
            subProcessings: (item.attributes.subprocessings.data || []).map(sub => ({
                id: sub.id,
                title: sub.attributes.title,
                description: sub.attributes.description,
            })),
            subtitle:item.attributes.subtitle,
        }));
        
        setProcessings(simplifiedProcessings);
    };

    return {
        processings,
        setProcessings,
        getCredentials,
        retrieveProcessings
    };
};